var Handlebars = require("../../../node_modules/handlebars/runtime.js");
function __default(obj) { return obj && (obj.__esModule ? obj["default"] : obj); }
module.exports = (Handlebars["default"] || Handlebars).template(function (Handlebars,depth0,helpers,partials,data) {
  this.compilerInfo = [4,'>= 1.0.0'];
helpers = this.merge(helpers, Handlebars.helpers); data = data || {};
  var buffer = "", stack1, functionType="function", escapeExpression=this.escapeExpression, self=this;

function program1(depth0,data) {
  
  var buffer = "", stack1;
  buffer += "\n    <p\n      class=\"p-cp-comment-more__user__icon\"\n      style=\"background: url("
    + escapeExpression(((stack1 = ((stack1 = (depth0 && depth0.User)),stack1 == null || stack1 === false ? stack1 : stack1.image_url)),typeof stack1 === functionType ? stack1.apply(depth0) : stack1))
    + ") no-repeat center; background-size: contain\"></p>\n  ";
  return buffer;
  }

  buffer += "<p class=\"p-cp-comment-more__desc\">\n  以前のコメントをみる\n</p>\n<div class=\"p-cp-comment-more__user\">\n  <p\n    class=\"p-cp-comment-more__user__icon\"\n    style=\"background: url(https://cdn.mamari.jp/static/mamariQ/img/campaign/common/icon_comment-more.png) no-repeat center; background-size: contain\"></p>\n\n  ";
  stack1 = helpers.each.call(depth0, depth0, {hash:{},inverse:self.noop,fn:self.program(1, program1, data),data:data});
  if(stack1 || stack1 === 0) { buffer += stack1; }
  buffer += "\n</div>\n";
  return buffer;
  });


//////////////////
// WEBPACK FOOTER
// ./webroot/hbs/load_campaign_comment.hbs
// module id = 216
// module chunks = 0